import { useState, useEffect } from "react";

interface UseEasterEggOptions {
	secretWord: string;
}

export function useEasterEgg({ secretWord }: UseEasterEggOptions): boolean {
	const [showEasterEgg, setShowEasterEgg] = useState(false);
	const [typedKeys, setTypedKeys] = useState("");

	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (!e.key) return;
			const newKeys = (typedKeys + e.key.toLowerCase()).slice(
				-secretWord.length
			);
			setTypedKeys(newKeys);

			if (newKeys === secretWord) {
				setShowEasterEgg((prev) => !prev);
				setTypedKeys("");
			}
		};

		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [typedKeys, secretWord]);

	return showEasterEgg;
}
